import { useEffect, useState } from "react";
import { _BudgetID, _single } from "../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../core/services/dataBean/useDataBean"
import { BasicPage } from "../theme/Component/BasicPage"
import { YearSelector } from "../../core/shared/inputs/YearSelector";
import { BasicButton } from "../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { PrintJson } from "../theme/Component/PrintJson";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../theme/Component/BasicTable";
import usePaginator from "../theme/Component/usePaginator";
import { AccountEditor } from "../editor/AccountEditor";
import { SelectProject } from "../erp/cellEditor/BudgetAccountantOperation/SelectProject";

export const BudgetReportContract = () => {

    const _budget = useDataBean(_BudgetID);
    const { instance, lista, setLista, bean, setBean } = _budget;
    const [data, setData] = useState<any>({

    });
    const [year, setYear] = useState<number>(_single.getCurrenYear());
    const [type, setType] = useState<number>(26);
    const paginador = usePaginator();

    useEffect(() => {
        getContractBudgetReport();
    }, [paginador.page])
    useEffect(() => {
        paginador.setPage(1);
    }, [data])

    const getContractBudgetReport = () => {
        console.log(data);
        
        let filter = _single.cleanMap(data);
        if(year>0 )
        {
            instance.getBudgetDescriptionReport(paginador.page,15,year,null,filter).then(
                (resp:any)=>{
                    if(resp.List)
                    {                        
                        setLista(resp.List);
                        paginador.setPages(resp.NumberOfPages);
                    }
                }
            ).catch(err => toast.error(err));

        } else {
            toast.warning("Año y tipo de presupuesto obligatorio");
        }
    }

    const head25 = [
        { title: 'Nit', property: 'SupplierNameNit', visible: false, mask: MASK_NUMBER },
        { title: 'Proveedor', property: 'SupplierName', visible: true },
        { title: 'Proyecto', property: 'NameProject', visible: true },
        { title: 'Cod. Contrato', property: 'Code', visible: true },
        { title: 'Cod. Int. Contrato', property: 'InternalCode', visible: false },
        { title: 'Objecto', property: 'DescriptionItem', visible: true },
        { title: 'Codigo Rubro', property: 'BudgetIDStr', visible: true },
        { title: 'Nombre Rubro', property: 'NameBudget', visible: true },
        { title: 'Recurso', property: 'NameBudgetResource', visible: false },
        { title: 'Fuente', property: 'NameBudgetSource', visible: false },

        { title: 'RCDP', property: 'RCDPValue', visible: true, mask: MASK_MONEY },
        { title: 'CDP', property: 'CDPValue', visible: true, mask: MASK_MONEY },
        { title: 'RP', property: 'RPValue', visible: true, mask: MASK_MONEY },
        { title: 'OB', property: 'OBValue', visible: true, mask: MASK_MONEY },

    ]
    const head26 = [
        { title: 'Rubro', property: 'BudgetIDStr', visible: true },
        { title: 'Nombre', property: 'NameBudget', visible: true },
        { title: 'Recurso', property: 'NameBudgetResource', visible: true },
        { title: 'Fuente', property: 'NameBudgetSource', visible: true },
        { title: 'PI', property: 'PIValue', visible: true, mask: MASK_MONEY },
        { title: 'CC', property: 'CCValue', visible: true, mask: MASK_MONEY },

        { title: 'IAD', property: 'IADValue', visible: true, mask: MASK_MONEY },
        { title: 'AP', property: 'APValue', visible: true, mask: MASK_MONEY },
    ]

    return (
        <BasicPage titulo="Reporte Contratos">
            <div className="row">
                <div className="col-md-2">
                    <YearSelector value={year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-3">
                    <AccountEditor idAccount={data.IDAccount} label="Tercero" onChange={(e) => { setData({ ...data, "IDAccount": e.IDAccount }) }} />
                </div>
                <div className="col-md-3">
                    <SelectProject label="Proyecto" idSelector={data.IDProject} onChange={(e) => { setData({ ...data, "IDProject": e }) }} />
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 mt-3">
                    <BasicButton icon="" eventClick={getContractBudgetReport}>Buscar</BasicButton>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <BasicTable head={type == 25 ? head26 : head25} body={lista} rowSet={setBean}
                        pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador}
                    ></BasicTable>
                    {/* <PrintJson json={data} /> */}
                </div>
            </div>

        </BasicPage>
    )
}